import { createAsyncThunk } from '@reduxjs/toolkit';
import { BiddingAPI } from '@/api';
import { IApiError } from '@/models/apiError.model';
import { IGetBidsListDTO, IGetBidsListResponse } from '@/models/bidding.model';
import { formatApiError } from '@/utils';
import { BIDDING_SLICE_NAME } from './models';

export const getBidsList = createAsyncThunk<IGetBidsListResponse, IGetBidsListDTO, { serializedErrorType: IApiError }>(
  `${BIDDING_SLICE_NAME}/getBidsList`,
  async (data) => {
    const response = await BiddingAPI.getBidsList(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
